import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  title: {
    fontWeight: 500,
  },
  footer: {
    textAlign: "center",
  },
  visaDisclaimer: {
    marginTop: 0,
  },
};
